import { defineMessages } from 'react-intl';

const messages = defineMessages({
  transactionCode: {
    id: 'App.Components.ProRateSection.ProRatedAmounts.TransactionCode',
    defaultMessage: 'Transaction Code',
  },
  description: {
    id: 'App.Components.ProRateSection.ProRatedAmounts.Description',
    defaultMessage: 'Description',
  },
  transactionType: {
    id: 'App.Components.ProRateSection.ProRatedAmounts.TransactionType',
    defaultMessage: 'Transaction Type',
  },
  monthlyRecurringAmount: {
    id: 'App.Components.ProRateSection.ProRatedAmounts.MonthlyRecurringAmount',
    defaultMessage: 'Monthly Recurring Amount',
  },
  moveOutCredit: {
    id: 'App.Components.ProRateSection.ProRatedAmounts.MoveOutCredit',
    defaultMessage: 'Move-Out {type} Credit',
  },
  moveInAmount: {
    id: 'App.Components.ProRateSection.ProRatedAmounts.MoveInAmount',
    defaultMessage: 'Move-In {type} Amount',
  },
  proRated: {
    id: 'App.Components.ProRateSection.ProRatedAmounts.ProRated',
    defaultMessage: 'Prorated',
  },
  full: {
    id: 'App.Components.ProRateSection.ProRatedAmounts.Full',
    defaultMessage: 'Full',
  },
});

export default messages;
